export enum AuthStatus {
  NOT_INITIALIZED = 'NOT_INITIALIZED',
  ANONYMOUS = 'ANONYMOUS',
  WAITING_FOR_SERVER = 'WAITING_FOR_SERVER',
  LOGGED = 'LOGGED',
  UNLOGGED = 'UNLOGGED'
}
